/** Login page with forgot-password OTP flow open on mount. */
export const FORGOT_PASSWORD_LOGIN_PATH = '/login?forgot=1' as const;

export const FORGOT_PASSWORD_QUERY_KEY = 'forgot' as const;
export const FORGOT_PASSWORD_QUERY_VALUE = '1' as const;

export function isForgotPasswordLogin(searchParams: URLSearchParams): boolean {
  return searchParams.get(FORGOT_PASSWORD_QUERY_KEY) === FORGOT_PASSWORD_QUERY_VALUE;
}
